import useEntranceAnimation from '../../client/hooks/useEntranceAnimation';
import AnimatedBar from './AnimatedBar';
import type { TrendProviderComparisonRow } from '../types';

type ProviderComparisonChartProps = {
  data: TrendProviderComparisonRow[];
};

export default function ProviderComparisonChart({
  data,
}: ProviderComparisonChartProps) {
  const animated = useEntranceAnimation();
  const sorted = [...data].sort(
    (a, b) => b.positiveCoverage - a.positiveCoverage,
  );

  if (sorted.length === 0) {
    return (
      <div className="flex h-48 items-center justify-center text-sm text-neutral-400 dark:text-neutral-500">
        No source data for this period
      </div>
    );
  }

  return (
    <div className="space-y-2.5" role="list" aria-label="Source quality">
      {sorted.map((p, i) => (
        <AnimatedBar
          key={p.provider}
          label={p.provider}
          value={`${Math.round(p.positiveCoverage * 100)}%`}
          percent={Math.round(p.positiveCoverage * 100)}
          usePrimaryColor
          labelWidth="w-28"
          valueWidth="w-12"
          animated={animated}
          index={i}
        />
      ))}
    </div>
  );
}
